/** XXL Print configurator color tokens */
export const XXL_COLORS = {
  primary: '#0c0c0c',
  primaryDark: '#000000',
  primaryContrast: '#ffffff',
  accent: '#7dd3fc',
  /** #7dd3fc darkened ~15% for hover/active states */
  accentDark: '#6ab3d6',
  textBase: '#595959',
  /** Secondary/muted text — new in the 2026-07 brand refresh */
  textMuted: '#a3a3a3',
  sectionTitle: '#1a1a1a',
  pageBackground: '#f6f6f6',
  paperBackground: '#ffffff',
  inputBackground: '#ffffff',
  borderLight: '#ececec',
  borderDefault: '#e2e2e2',
  borderMedium: '#cccccc',
  /** Structural near-black border for primary containers/controls (brutalist) */
  borderStrong: '#0c0c0c',
  tileSelectedBg: '#eff9fe',
  tileSelectedBorder: '#7dd3fc',
  /** Neutral hover fill for editor controls (keeps cyan reserved for "active") */
  surfaceMuted: '#fafafa',
  /** Subtle tint for the header of an open/active editor card */
  selectedTint: '#f4fafe',
  canvasBackground: '#f6f6f6',
  // Measurement rulers/labels are passive annotations, not an "active" state —
  // neutral black keeps cyan reserved for the live selection (box + delete control).
  rulerAccent: '#0c0c0c',
  /** Dark brand surface (#0C0C0C) used for header + price footer anchors */
  surfaceDark: '#0c0c0c',
  /** Text/icon color on dark surfaces */
  textOnDark: '#ffffff',
} as const;
